import './Footer.scss';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Youtube from '../../assets/Youtube.png'
import fb from '../../assets/fb.png';
import { Link } from 'react-router-dom';
import axios from 'axios';
import logo from '../../assets/logo.png';

const Footer = () => {
  const [showModal, setShowModal] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();


  const year = new Date().getFullYear();

  //checks for existing session and does not allow login if already logged in or any duplicate login attempts
  // const handleLogin = (e) => {
  //   e.preventDefault();

  //   const existingSession = sessionStorage.getItem('isLoggedIn');

  //   if (existingSession) {
  //     alert("You are already logged in. Please logout first.");
  //     return;
  //   }

  //   // Generate a unique LoginID
  //   const LoginID = `LoginID${Math.floor(100 + Math.random() * 900)}`;


  //   // Dummy credentials for admin login
  //   if (username === 'admin' && password === '1234') {
  //     const now = new Date();
  //     sessionStorage.setItem('isLoggedIn', 'true');
  //     sessionStorage.setItem('loginTime', now.toLocaleTimeString());
  //     sessionStorage.setItem('loginDate', now.toDateString());
  //     sessionStorage.setItem('username', username);
  //     sessionStorage.setItem('LoginID', LoginID); 


  //     setShowModal(false);
  //     navigate('/admin/dashboard');
  //   } else {
  //     alert('Invalid credentials!');
  //   }
  // };




//with api

 const handleLogin = async (e) => {
  e.preventDefault();

  try {
    const response = await axios.post('https://core-c343.onrender.com/api/admin/login', {
      username,
      password
    });

    // ✅ Data returned from backend
    const { LoginID, loginTime, loginDate } = response.data;

    // Save minimal session on frontend
    sessionStorage.setItem('isLoggedIn', 'true');
    sessionStorage.setItem('LoginID', LoginID);
    sessionStorage.setItem('loginTime', loginTime);
    sessionStorage.setItem('loginDate', loginDate);
    sessionStorage.setItem('username', username);

    navigate('/admin/dashboard');

  } catch (err) {
    alert(err?.response?.data?.error || 'Admin rights required');
  }
};












  return (
    <>
      <footer className="footer">
        <div className="footer-content">
          {/* About Section */}
          <div className="footer__details">
            {/* <h1 className="logo">Divya Jyotisa</h1> */}
            <div className="logo-pic">
              <img src={logo} alt="logo" />
            </div>
            
            <p>
              Divya Jyotisa brings cosmic guidance to your daily life.
              Explore the universe with personalized horoscopes, astrology insights, and spiritual advice.
            </p>
            
          </div>

          {/* Links */}
           
          <nav className="footer__links">
            <h3>Useful Links</h3>
            <div className="extra">
              <div className="more-links">
              <ul>
                <li><a href="/#home">Home</a></li>
                <li><a href="/#services">Services</a></li>
                <li><a href="/about-us">About Us</a></li>
                <li><a href="/#contact">Contact Us</a></li>
                <li><a href="/privacy">Privacy Policy</a></li>
                <li><a href="/terms">Terms & Conditions</a></li>
                <li><a href="/refund">Refund Policy</a></li>
                <li><span className="admin-link" onClick={() => setShowModal(true)}>Admin Panel</span></li>
              </ul>
              </div>
              <div className="more-links">
              <ul>
<li><a href="/panchang/monthly">Panchang</a></li>
<li><a href="/calender/hindu">Calender</a></li>
<li><a href="/muhurat/chogadiya">Muhurat</a></li>
<li><a href="/vrat/sankashti-chaturthi">Vrat</a></li>
{/* <li><a href="/#jyotish">Jyotish</a></li> */}
<li><a href="/planets/planetary-positions">Planets</a></li>
<li><a href="/numerology/luckynum">Numerology</a></li>
<li><a href="/festival/hindufest">Festivals</a></li>

               </ul>
              </div>
           </div> 
          </nav>


          {/* Blog */}
          <div className="footer__vlog">
            <h3>📹 Contact Us</h3>
            <p>Catch our latest astrology videos and cosmic updates on our YouTube Blog!</p>
            <p>✨ Learn about daily horoscopes, planetary movements, and more in a simple and fun way.</p>
            <div className="subscribe">
           <h3>Subscribe</h3>
            <form>
              <input type="email" placeholder="Enter your email" required />
              <button type="submit">Send Message</button>
            </form>
          </div>
           </div>

          {/* contact-item */}
          <div className="contacts-items">
          <div className="contact-item">
              <LocalPhoneOutlinedIcon />
              <div>
                <p className="label">Phone</p>
                <p>+91 93824 81286</p>
                {/* <p>+91 93824 81286</p> */}
              </div>
            </div>
            

             <div className="contact-item">
              <EmailOutlinedIcon />
              <div>
                <p className="label">Email</p>
                <p className='hi'><a href="mailto:Punam@AsthaDDestiny.com">Punam@AsthaDDestiny.com</a></p>
                <p className='hi'><a href="mailto:Punam@AsthaDDestiny.com">astha.ddestiny9@gmail.com</a></p>
              </div>
            </div>
            <div className="contact-item">
              <LocationOnIcon />
              <div>
                <p className="label">Address</p>
                <p>Kappa Shine 1A, Kalipark, Rajarhat , Kolkata - 700136</p>
              </div>
            </div>
            <div className="icons">
                              <Link to="https://www.linkedin.com/company/ashtha-d-destiny/" target="_blank" rel="noopener noreferrer">
                  <LinkedInIcon />
                </Link>
                <Link to="https://x.com/AsthaDDestiny?mx=2" target="_blank" rel="noopener noreferrer">
                  <TwitterIcon />
                </Link>
                <Link to="https://www.facebook.com/astronumerovastu/" target="_blank" rel="noopener noreferrer">
                  <img src={fb} alt="Facebook icon" />
                </Link>
                <Link to="https://www.instagram.com/astha_d_destiny/" target="_blank" rel="noopener noreferrer">
                  <InstagramIcon />
                </Link>
                 <a href="https://www.youtube.com/@astha.ddestiny3592" target="_blank" rel="noopener noreferrer">
                <img src={Youtube} alt="YouTube" />
              </a>
            </div>
           </div>
            
         

          

        </div>

        <div className="privacy">
          <p>All rights reserved. ©{year} Divya Jyotisa.</p>
          <p> Developed and maintained by <Link to = 'https://rjrinfinity.com/'>RJR Infinity</Link>.</p>
        </div>
      </footer>

      {/* Modal Popup */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h2>Admin Login</h2>
            <form onSubmit={handleLogin}>
              <input
                type="text"
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button type="submit">Login</button>
            </form>
            <button className="close-btn" onClick={() => setShowModal(false)}>Close</button>
          </div>
        </div>
      )}
    </>
  );
};

export default Footer;
